import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import moment from "moment";

import { CommonService } from "../js_modules/CommonService";

import { SellToWebAdminFormComboBoxComponent } from "../common/selltowebcombobox/SellToWebAdminFormComboBoxComponent";
import { SellToWebAdminModalDialogComponent } from "../common/selltowebmodaldialog/SellToWebAdminModalDialogComponent";
import { SellToWebModalDialogHeaderButtonComponent } from "../common/selltowebmodaldialog/SellToWebModalDialogHeaderButtonComponent";
import { SellToWebTableHeaderComponent } from "../common/selltowebtable/SellToWebTableHeaderComponent";
import { SellToWebTableColumnComponent } from "../common/selltowebtable/SellToWebTableColumnComponent";
import { SellToWebTableRowComponent } from "../common/selltowebtable/SellToWebTableRowComponent";
import { SellToWebTableComponent } from "../common/selltowebtable/SellToWebTableComponent";

import { EVOXImagesMMREVOXMappingQueryComponent } from "./EVOXImagesMMREVOXMappingQueryComponent";
import { EVOXImagesComponent } from "./EVOXImagesComponent";
import { SellToWebSpinnerComponent } from "../common/selltowebspinner/SellToWebSpinnerComponent";

export class EVOXImagesMMREVOXMappingComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showConfirmation: false,
            saveTableData: [],
            savePaintTable: false,
            tableData: [],
            tableTitle: "",
            paintTable: false,
            vifData: null,
            vifDict: null,
            isLoadingData: false,
            imageType: "Front",
            evoxPhotoRowData: null,
            evoxVehicleOEMColors: null,
            selectedEVOXVehicleOEMColors: null,
            selectedYear: null,
            selectedMake: null,
            selectedView: null,
            vifNumber: null
        };

        this.onVIFDataColumnCallback = this.onVIFDataColumnCallback.bind(this);
        this.onActionColumnCallback = this.onActionColumnCallback.bind(this);
        this.onMappedByColumnCallback = this.onMappedByColumnCallback.bind(this);
        this.onPhotoColumnCallback = this.onPhotoColumnCallback.bind(this);
        this.onMappingChange = this.onMappingChange.bind(this);
        this.onMappingClick = this.onMappingClick.bind(this);
        this.onGetReportClick = this.onGetReportClick.bind(this);
        this.onSaveAllClick = this.onSaveAllClick.bind(this);
        this.onSaveToModelClick = this.onSaveToModelClick.bind(this);
        this.onConfirmSaveAllClick = this.onConfirmSaveAllClick.bind(this);
        this.onCancelSaveAllClick = this.onCancelSaveAllClick.bind(this);
        this.onSaveClick = this.onSaveClick.bind(this);
        this.onUndoClick = this.onUndoClick.bind(this);
        this.onDeleteClick = this.onDeleteClick.bind(this);
        this.onShowEVOXPhotosClick = this.onShowEVOXPhotosClick.bind(this);
        this.onCancelEVOXPhotosClick = this.onCancelEVOXPhotosClick.bind(this);
        this.onRowKeyDown = this.onRowKeyDown.bind(this);
        this.onVifNumberColumnCallback = this.onVifNumberColumnCallback.bind(this);

        props.onPageChanged({
            pageTitle: this.pageTitle,
            override: true,
            link: {
                name: this.pageTitle,
                action: "add"
            }
        });

        //console.devLog("State: " + CommonService.getComponentConstructorData(this.state));
        //console.devLog("Props: " + CommonService.getComponentConstructorData(this.props));
    }

    pageTitle = "EVOX Images";
    imageBaseUrl = "https://cdn.acquirecars.com/image/EVOX/VIF/";
    legendText = <div className="text-nowrap d-inline">
        <div className="d-inline admin-legend admin-evox-images-bg-modified" />&nbsp;&nbsp;&nbsp;Modified
        <div className="d-inline admin-legend admin-evox-images-inactive-mapping" />&nbsp;&nbsp;&nbsp;Inactive
        <div className="d-inline admin-legend admin-evox-images-hidden" />&nbsp;&nbsp;&nbsp;Hidden
        <div className="d-inline admin-legend admin-evox-images-model-mapping" />&nbsp;&nbsp;&nbsp;Model Mapping
    </div>;

    componentDidMount() {
        try {
            this.props.applicationInsights.trackPageView({ name: this.pageTitle, url: "/EVOXImages/MMREVOXMapping", properties: { logon: this.props.remoteUpn, position_code: this.props.positionCode } });
            this.getVifList();
        }
        catch (error) {
            console.logError(error, "EVOXImagesMMREVOXMappingComponent", "componentDidMount");
        }
    }

    getVifList() {
        this.props.applicationInsights.trackTrace({ message: "/EVOXImagesMMREVOXMappingComponent/GetVIFList", properties: { logon: this.props.remoteUpn, position_code: this.props.positionCode } });
        fetch("/EVOXImages/GetVIFList")
            .then(response => { if (response.ok) { return response.json(); } else { throw response; } })
            .then(parsedResponse => {
                let vifDict = {};
                parsedResponse.table.forEach((responseItem, index) => {
                    vifDict[responseItem.vifNumber.toString()] = responseItem;
                });
                this.setState({
                    vifData: parsedResponse.table,
                    vifDict: vifDict
                });
            })
            .catch(notOKResponse => {
                if (notOKResponse.status === 500) {
                    notOKResponse.json()
                        .then(parsedError => {
                            this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/EVOXImages/GetVIFList", ...parsedError, logon: this.props.remoteUpn ?? "", positionCode: this.props.positionCode ?? "" } });
                            console.logError(parsedError, "EVOXImagesMMREVOXMappingComponent", "getVifList");
                            this.props.onShowAlert("danger", parsedError);
                        })
                        .catch(jsonParseError => {
                            console.logError(jsonParseError, "EVOXImagesMMREVOXMappingComponent", "getVifList");
                        });
                }
            });
    }

    onVIFDataColumnCallback(rowData) {
        try {
            let rowId = "vif_" + rowData.id;
            let vifList = rowData.showMapping ? (rowData.vifList ? rowData.vifList : this.state.vifData.filter(data => data.year === rowData.year)) : null;

            return <SellToWebAdminFormComboBoxComponent
                id={rowId} data={vifList} additionalData={rowData} itemKey="displayName" placeHolder="Type to filter vehicles" value={rowData.evoxDisplayName} colSpan="col-12" autoDrop
                onItemChange={this.onMappingChange} onItemClick={this.onMappingClick} onKeyDown={this.onRowKeyDown} />
        }
        catch (error) {
            console.logError(error, "EVOXImagesMMREVOXMappingComponent", "onVIFDataColumnCallback");
        }
    }

    onActionColumnCallback(rowData) {
        try {
            return <div className="form-inline text-nowrap">
                <button className="btn btn-link admin-tooltip" onClick={(event) => this.onSaveClick(event, rowData)} style={{ "padding": "5px" }} tabIndex="-1" disabled={rowData.disabledSave}>
                    <i className="fas fa-save" />
                </button>
                <button className="btn btn-link admin-tooltip" onClick={(event) => this.onSaveToModelClick(event, rowData)} style={{ "padding": "5px" }} tabIndex="-1" disabled={rowData.disabledSave}>
                    <i className="fa-solid fa-rectangle-history" />
                </button>
                <button className="btn btn-link admin-tooltip" disabled={rowData.originalVIFNumber === rowData.vifNumber} onClick={(event) => this.onUndoClick(event, rowData)} style={{ "padding": "5px" }} tabIndex="-1">
                    <i className="fas fa-undo" />
                </button>
                <button className="btn btn-link admin-tooltip" disabled={!rowData.vifNumber} onClick={(event) => this.onDeleteClick(event, rowData)} style={{ "padding": "5px", "marginLeft": "-10px" }} tabIndex="-1">
                    <i className="fas fa-times text-danger" />
                </button>
                <SellToWebSpinnerComponent showSpinner={rowData.action_showSpinner} />
            </div>;
        }
        catch (error) {
            console.logError(error, "EVOXImagesMMREVOXMappingComponent", "onActionColumnCallback");
        }
    }

    onMappedByColumnCallback(rowData) {
        try {
            if (rowData.vifMappedBy) {
                return <div>
                    {rowData.vifMappedBy}<br />
                    <span className="text-nowrap">{rowData.vif_mapped_on ? "(" + CommonService.formatDateTime_2(moment(rowData.vif_mapped_on)) + ")" : ''}</span>
                </div>;
            }

            return "";
        }
        catch (error) {
            console.logError(error, "EVOXImagesMMREVOXMappingComponent", "onMappedByColumnCallback");
        }
    }

    onPhotoColumnCallback(rowData) {
        return <Fragment>
            {
                rowData.vifNumber
                    ? <button type="button" className="btn btn-link" onClick={(event) => this.onShowEVOXPhotosClick(event, rowData)} tabIndex="-1">
                        EVOX
                    </button>
                    : <button type="button" className="btn btn-link" disabled>
                        EVOX
                    </button>
            }
        </Fragment>;
    }

    onMappingChange(elementId, filterValue) {
        try {
            let tableData = this.state.tableData;
            let id = parseInt(elementId.split('_')[1]);
            let rowData = tableData.filter((row) => row.id === id)[0];
            let filteredData = [];
            if (this.state.vifData) {
                filteredData = this.state.vifData.filter(vifRow => {
                    return vifRow.displayName.toLowerCase().includes(filterValue.toLowerCase());
                });
            }
            if (filteredData.length === 1) {
                rowData.vifNumber = filteredData[0].vifNumber;
            }
            if (rowData.evoxDisplayName !== filterValue && filteredData.length === 1) {
                rowData.rowClassName = "admin-evox-images-bg-modified";
            }
            rowData.vifList = filteredData;
            rowData.evoxDisplayName = filterValue;
            rowData.showMapping = true;

            if (!filterValue && rowData.originalVIFNumber) {
                rowData.rowClassName = "admin-evox-images-bg-modified";
                rowData.vifNumber = "";
            }

            this.setState({
                tableData: tableData,
                paintTable: true
            }, () => {
                this.setState({ paintTable: false });
            });
        }
        catch (error) {
            console.logError(error, "EVOXImagesMMREVOXMappingComponent", "onMappingChange");
        }
    }

    onMappingClick(elementId, selectedItem) {
        try {
            let tableData = this.state.tableData;
            let id = parseInt(elementId.split('_')[1]);
            let rowData = tableData.filter((row) => row.id === id)[0];
            rowData.vifList = null;
            rowData.vifNumber = selectedItem.vifNumber;
            rowData.showMapping = false;
            rowData.disabledSave = true;
            if (rowData.vifNumber) {
                let matchedVIF = this.state.vifDict[rowData.vifNumber.toString()];
                if (matchedVIF) {
                    rowData.disabledSave = false;
                    rowData.evoxDisplayName = matchedVIF.displayName;
                }
            }

            if (rowData.originalVIFNumber !== rowData.vifNumber) {
                rowData.rowClassName = "admin-evox-images-bg-modified";
            }

            this.setState({
                tableData: tableData,
                paintTable: true
            }, () => {
                this.setState({ paintTable: false });
            });
        }
        catch (error) {
            console.logError(error, "EVOXImagesMMREVOXMappingComponent", "onMappingClick");
        }
    }

    onGetReportClick(selectedYear, selectedMake, selectedView, vifNumber) {
        try {
            this.setState({
                isLoadingData: true,
                selectedYear: selectedYear,
                selectedMake: selectedMake,
                selectedView: selectedView,
                vifNumber: vifNumber
            });
            let inputData = {
                year: selectedYear ? CommonService.formatYear(selectedYear) : null,
                makeName: selectedMake && selectedMake.make !== "All" ? selectedMake.make : null,
                view: selectedView ? selectedView.key : null,
                vifNumber: vifNumber
            };
            this.props.applicationInsights.trackTrace({ message: "/EVOXImagesMMREVOXMappingComponent/onGetReportClick", properties: { ...inputData, logon: this.props.remoteUpn, position_code: this.props.positionCode } });
            fetch("/EVOXImages/GetMMREVOXMappings", {
                method: "POST",
                headers: {
                    'Content-Type': "application/json; charset=utf-8;"
                },
                body: JSON.stringify(inputData)
            })
                .then(response => { if (response.ok) { return response.json() } else { throw response; } })
                .then(parsedResponse => {
                    let tableData = parsedResponse.table;
                    tableData.forEach((rowData) => {
                        rowData.originalVIFNumber = rowData.vifNumber;
                        rowData.disabledSave = true;
                        if (!rowData.vifNumber) {
                            rowData.evoxDisplayName = rowData.year + " " + rowData.makeName.replace("B M W", "BMW");
                        }

                        if (rowData.status === "Inactive") {
                            rowData.rowClassName = "admin-evox-images-inactive-mapping";
                        }
                        else if (rowData.status === "Hidden") {
                            rowData.rowClassName = "admin-evox-images-hidden";
                        }
                        else if (rowData.comment?.startsWith("Model mapped for")) {
                            rowData.rowClassName = "admin-evox-images-model-mapping";
                        }
                    });

                    this.setState({
                        isLoadingData: false,
                        tableData: CommonService.addOrdinalColumn(tableData),
                        tableTitle: "MMR EVOX Mapping - " + (selectedYear ? CommonService.formatYear(selectedYear) : "All"),
                        paintTable: true
                    }, () => {
                        this.setState({ paintTable: false });
                    });
                })
                .catch(notOKResponse => {
                    this.setState({ isLoadingData: false });
                    if (notOKResponse.status === 500) {
                        notOKResponse.json()
                            .then(parsedError => {
                                this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/EVOXImages/GetMMREVOXMappings", ...inputData, ...parsedError, logon: this.props.remoteUpn ?? "", positionCode: this.props.positionCode ?? "" } });
                                console.logError(parsedError, "EVOXImagesMMREVOXMappingComponent", "onGetReportClick");
                                this.props.onShowAlert("danger", parsedError);
                            })
                            .catch(jsonParseError => {
                                console.logError(jsonParseError, "EVOXImagesMMREVOXMappingComponent", "onGetReportClick");
                            });
                    }
                });
        }
        catch (error) {
            console.logError(error, "EVOXImagesMMREVOXMappingComponent", "onGetReportClick");
        }
    }

    onSaveAllClick(selectedYear) {
        try {
            let saveTableData = [];
            saveTableData = this.state.tableData.filter(item => item.rowClassName === "admin-evox-images-bg-modified");
            this.setState({
                showConfirmation: true,
                saveTableData: saveTableData,
                savePaintTable: true
            }, () => {
                this.setState({ savePaintTable: false });
            });
        }
        catch (error) {
            console.logError(error, "EVOXImagesMMREVOXMappingComponent", "onSaveAllClick");
        }
    }

    onConfirmSaveAllClick(event) {
        try {
            let saveData = [];
            this.state.saveTableData.forEach((rowData) => {
                rowData.action_showSpinner = true;
                saveData.push({
                    id: rowData.id,
                    vifNumber: rowData.vifNumber
                });
            });

            if (saveData.length > 0) {
                this.setState({
                    isLoadingData: true,
                    paintTable: true
                });

                let inputData = saveData;
                this.props.applicationInsights.trackTrace({ message: "/EVOXImagesMMREVOXMappingComponent/onConfirmSaveAllClick", properties: { ...inputData, logon: this.props.remoteUpn, position_code: this.props.positionCode } });
                fetch("/EVOXImages/SaveMMREVOXMappings", {
                    method: "POST",
                    headers: {
                        'Content-Type': "application/json; charset=utf-8;"
                    },
                    body: JSON.stringify(inputData)
                })
                    .then(response => { if (response.ok) { return response.json() } else { throw response; } })
                    .then(parsedResponse => {
                        this.state.saveTableData.forEach((saveTableRow) => {
                            saveTableRow.showUndo = saveTableRow.originalVIFNumber !== saveTableRow.vifNumber;
                            saveTableRow.action_showSpinner = false;
                            saveTableRow.rowClassName = null;
                            saveTableRow.vifMappedBy = saveTableRow.vifNumber ? this.props.remoteUpn : null;
                            saveTableRow.vif_mapped_on = saveTableRow.vifNumber ? moment() : null;
                        });

                        this.setState({
                            isLoadingData: false,
                            paintTable: true
                        }, () => {
                            this.setState({ paintTable: false })
                        });
                        this.onCancelSaveAllClick(event);
                    })
                    .catch(notOKResponse => {
                        this.state.saveTableData.forEach((saveTableRow) => {
                            saveTableRow.action_showSpinner = false;
                        });

                        this.setState({
                            isLoadingData: false,
                            paintTable: true
                        }, () => {
                            this.setState({ paintTable: false })
                        });
                        this.onCancelSaveAllClick(event);
                        if (notOKResponse.status === 500) {
                            notOKResponse.json()
                                .then(parsedError => {
                                    this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/EVOXImages/onConfirmSaveAllClick", ...inputData, ...parsedError, logon: this.props.remoteUpn ?? "", positionCode: this.props.positionCode ?? "" } });
                                    console.logError(parsedError, "EVOXImagesMMREVOXMappingComponent", "onConfirmSaveAllClick");
                                    this.props.onShowAlert("danger", parsedError);
                                })
                                .catch(jsonParseError => {
                                    console.logError(jsonParseError, "EVOXImagesMMREVOXMappingComponent", "onConfirmSaveAllClick");
                                });
                        }
                    });
            }
            else {
                this.setState({
                    paintTable: true
                }, () => {
                    this.setState({ paintTable: false })
                });
            }
        }
        catch (error) {
            this.setState({ isLoadingData: false });
            console.logError(error, "EVOXImagesMMREVOXMappingComponent", "onConfirmSaveAllClick");
        }
    }

    onCancelSaveAllClick(event) {
        try {
            this.setState({
                showConfirmation: false,
                saveTableData: [],
                savePaintTable: true
            }, () => {
                this.setState({ savePaintTable: false });
            });
        }
        catch (error) {
            console.logError(error, "EVOXImagesMMREVOXMappingComponent", "onCancelSaveAllClick");
        }
    }

    onSaveClick(event, rowData) {
        try {
            this.setState({
                saveTableData: [rowData]
            }, this.onConfirmSaveAllClick);
        }
        catch (error) {
            console.logError(error, "EVOXImagesMMREVOXMappingComponent", "onSaveClick");
        }
    }

    onSaveToModelClick(event, rowData) {
        try {
            let tableData = this.state.tableData;
            rowData.action_showSpinner = true;
            this.setState({
                tableData: tableData,
                paintTable: true
            });
            let inputData = ({
                id: rowData.id,
                vifNumber: rowData.vifNumber,
            });
            this.props.applicationInsights.trackTrace({ message: "/EVOXImagesMMREVOXMappingComponent/onSaveToModelClick", properties: { ...inputData, logon: this.props.remoteUpn, position_code: this.props.positionCode } });
            fetch("/EVOXImages/SaveMMRModelEvoxMappings", {
                method: "POST",
                headers: {
                    'Content-Type': "application/json; charset=utf-8;"
                },
                body: JSON.stringify(inputData)
            })
                .then(response => { if (response.ok) { return response.json() } else { throw response; } })
                .then(parsedResponse => {
                    rowData.action_showSpinner = false;
                    rowData.rowClassName = null;
                    rowData.vifMappedBy = rowData.vifNumber ? this.props.remoteUpn : null;
                    rowData.vifMappedOn = rowData.vifNumber ? moment() : null;
                    this.setState({
                        tableData: tableData,
                        showUndo: rowData.originalVIFNumber !== rowData.vifNumber,
                        paintTable: true
                    }, () => {
                        this.setState({ paintTable: false })
                    });
                    this.onGetReportClick(this.state.selectedYear, this.state.selectedMake, this.state.selectedView, this.state.vifNumber);
                })
                .catch(notOKResponse => {
                    rowData.action_showSpinner = false;
                    this.setState({
                        tableData: tableData,
                        paintTable: true
                    }, () => {
                        this.setState({ paintTable: false })
                    });
                    if (notOKResponse.status === 500) {
                        notOKResponse.json()
                            .then(parsedError => {
                                this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/EVOXImages/SaveMMRModelEvoxMappings", ...inputData, ...parsedError, logon: this.props.remoteUpn ?? "", positionCode: this.props.positionCode ?? "" } });
                                console.logError(parsedError, "EVOXImagesMMREVOXMappingComponent", "onSaveToModelClick");
                                this.props.onShowAlert("danger", parsedError);
                            })
                            .catch(jsonParseError => {
                                console.logError(jsonParseError, "EVOXImagesMMREVOXMappingComponent", "onSaveToModelClick");
                            });
                    }
                });
        }
        catch (error) {
            console.logError(error, "EVOXImagesMMREVOXMappingComponent", "onSaveToModelClick");
        }
    }

    onUndoClick(event, rowData) {
        try {
            rowData.rowClassName = null;
            rowData.vifNumber = rowData.originalVIFNumber;
            if (rowData.vifNumber) {
                let matchedVIF = this.state.vifDict[rowData.vifNumber.toString()];
                if (matchedVIF) {
                    rowData.evoxDisplayName = matchedVIF.displayName;
                }
            }
            else {
                rowData.evoxDisplayName = rowData.year + " " + rowData.makeName.replace("B M W", "BMW");
            }

            this.setState({
                saveTableData: [rowData]
            }, this.onConfirmSaveAllClick);
        }
        catch (error) {
            console.logError(error, "EVOXImagesMMREVOXMappingComponent", "onUndoClick");
        }
    }

    onDeleteClick(event, rowData) {
        try {
            rowData.originalVIFNumber = rowData.vifNumber;
            rowData.action_showSpinner = true;
            rowData.vifNumber = "";
            rowData.evoxDisplayName = rowData.year + " " + rowData.makeName.replace("B M W", "BMW");
            rowData.vifMappedBy = null;
            rowData.vif_mapped_on = null;

            this.setState({
                saveTableData: [rowData]
            }, this.onConfirmSaveAllClick);
        }
        catch (error) {
            console.logError(error, "EVOXImagesMMREVOXMappingComponent", "onDeleteClick");
        }
    }

    onShowEVOXPhotosClick(event, rowData) {
        try {
            this.setState({
                evoxPhotoRowData: rowData,
                imageType: "Front"
            });
            this.props.applicationInsights.trackTrace({ message: "/EVOXImagesMMREVOXMappingComponent/onShowEVOXPhotosClick", properties: { logon: this.props.remoteUpn, position_code: this.props.positionCode } });
            fetch("/EVOXImages/GetEVOXOEMColors/" + rowData.vifNumber)
                .then(response => { if (response.ok) { return response.json(); } else { throw response; } })
                .then(parsedResponse => {
                    if (parsedResponse.status) {
                        this.setState({
                            evoxVehicleOEMColors: parsedResponse,
                            selectedEVOXVehicleOEMColors: null
                        });
                    }
                    else {
                        let sortedOEMColors = CommonService.sortJsonData(parsedResponse, "whiteness", "desc");
                        this.setState({
                            evoxVehicleOEMColors: sortedOEMColors,
                            selectedEVOXVehicleOEMColors: sortedOEMColors[0]
                        });
                    }
                })
                .catch(notOKResponse => {
                    if (notOKResponse.status === 500) {
                        notOKResponse.json()
                            .then(parsedError => {
                                this.props.applicationInsights.trackException({ exception: parsedError, properties: { method: "/EVOXImages/GetEVOXOEMColors", ...parsedError, logon: this.props.remoteUpn ?? "", positionCode: this.props.positionCode ?? "" } });
                                console.logError(parsedError, "EVOXImagesMMREVOXMappingComponent", "onShowEVOXPhotosClick");
                                this.props.onShowAlert("danger", parsedError);
                            })
                            .catch(jsonParseError => {
                                console.logError(jsonParseError, "EVOXImagesMMREVOXMappingComponent", "onShowEVOXPhotosClick");
                            });
                    }
                });
        }
        catch (error) {
            console.logError(error, "EVOXImagesMMREVOXMappingComponent", "onShowEVOXPhotosClick");
        }
    }

    onCancelEVOXPhotosClick(event) {
        this.setState({
            evoxPhotoRowData: null,
            evoxVehicleOEMColors: null
        });
    }

    onRowKeyDown(event, rowData) {
        if (event.ctrlKey) {
            let charCode = String.fromCharCode(event.which).toLowerCase();
            switch (charCode) {
                case 's':
                    event.preventDefault();
                    this.onSaveClick(event, rowData);
                    break;

                case 'm':
                    event.preventDefault();
                    this.onSaveToModelClick(event, rowData);
                    break;

                case 'u':
                    if (rowData.vifNumber !== rowData.originalVIFNumber) {
                        event.preventDefault();
                        this.onUndoClick(event, rowData);
                    }
                    break;

                case 'r':
                    if (rowData.vifNumber) {
                        event.preventDefault();
                        this.onDeleteClick(event, rowData);
                    }
                    break;

                default:
                    break;
            }
        }
    }

    onVifNumberColumnCallback(rowData) {
        if (rowData.vifNumber)
            return <Link to={"/Global/EVOXImages/EVOXVehicles?vifNumber=" + rowData.vifNumber}>{rowData.vifNumber}</Link>;
    }

    render() {
        return <div className="admin-body admin-fill-content">
            <EVOXImagesComponent
                applicationInsights={this.props.applicationInsights}
                vehicleOEMColors={this.state.evoxVehicleOEMColors}
                photoRowData={this.state.evoxPhotoRowData}
                imageBaseUrl={this.imageBaseUrl}
                vehicleIdPropertyName="vifNumber"
                imageAlt="EVOX"
                titlePrefix="EVOX Photos"
                onCancelClick={this.onCancelEVOXPhotosClick}
                logPart2="EVOX image not found"
                onShowAlert={this.props.onShowAlert}
            />
            <SellToWebAdminModalDialogComponent
                applicationInsights={this.props.applicationInsights}
                showDialog={this.state.showConfirmation}
                className="admin-evox-mmr-save-dialog"
                title="Save MMR EVOX Mappings"
                onCancelClick={this.onCancelSaveAllClick}
            >
                <SellToWebModalDialogHeaderButtonComponent>
                    <button className="btn btn-primary" onClick={this.onConfirmSaveAllClick}>
                        Confirm <span className="fas fa-save admin-icon" />
                    </button>
                </SellToWebModalDialogHeaderButtonComponent>
                <SellToWebTableComponent applicationInsights={this.props.applicationInsights} cardClassName="admin-flex-item" headerText={this.state.tableTitle} tableData={this.state.saveTableData} paintTable={this.state.savePaintTable}>
                    <SellToWebTableHeaderComponent position="PreHeader">
                        <tr className="admin-table-header" style={{ "borderBottom": "1px solid #DCDCDC" }}>
                            <td colSpan="2" className="text-center font-weight-bold">MMR</td>
                            <td colSpan="5" className="text-center font-weight-bold">EVOX</td>
                        </tr>
                    </SellToWebTableHeaderComponent>
                    <SellToWebTableRowComponent>
                        <SellToWebTableColumnComponent headerText="Id" dataColumn="id" sortColumn="id" filterColumn="id" headerCssName="text-nowrap" />
                        <SellToWebTableColumnComponent headerText="YMMT" dataColumn="ymmt" sortColumn="ymmt" filterColumn="ymmt" />
                        <SellToWebTableColumnComponent headerText="YMMT" dataColumn="evoxDisplayName" sortColumn="evoxDisplayName" filterColumn="evoxDisplayName" />
                        <SellToWebTableColumnComponent headerText="Comment" dataColumn="comment" sortColumn="comment" filterColumn="comment" />
                        <SellToWebTableColumnComponent headerText="VIF" dataColumn="vifNumber" sortColumn="vifNumber" filterColumn="vifNumber" headerCssName="text-nowrap" />
                        <SellToWebTableColumnComponent headerText="Mapped By" sortColumn="vifMappedBy" filterColumn="vifMappedBy" headerCssName="text-nowrap" dataColumnCallback={this.onMappedByColumnCallback} />
                        <SellToWebTableColumnComponent headerText="Image Product" dataColumn="imageProductDownloaded" sortColumn="imageProductDownloaded" filterColumn="imageProductDownloaded" headerCssName="text-nowrap" />
                    </SellToWebTableRowComponent>
                </SellToWebTableComponent>
            </SellToWebAdminModalDialogComponent>
            <div className="d-flex flex-column admin-fill-content">
                <EVOXImagesMMREVOXMappingQueryComponent
                    applicationInsights={this.props.applicationInsights}
                    isLoadingData={this.state.isLoadingData} {...this.props}
                    onGetReportClick={this.onGetReportClick} onSaveAllClick={this.onSaveAllClick} onShowAlert={this.props.onShowAlert}
                />
                <br />
                <SellToWebTableComponent cardClassName="admin-flex-item" applicationInsights={this.props.applicationInsights} headerText={this.state.tableTitle} tableData={this.state.tableData} paintTable={this.state.paintTable} legendText={this.legendText}
                    tablePageSize={CommonService.tablePageSize} stickyHeader>
                    <SellToWebTableHeaderComponent position="PreHeader">
                        <tr className="admin-table-header" style={{ "borderBottom": "1px solid #DCDCDC" }}>
                            <td />
                            <td className="text-center font-weight-bold admin-evox-image-mmr">MMR</td>
                            <td colSpan="8" className="text-center font-weight-bold admin-evox-image-evox">EVOX</td>
                        </tr>
                    </SellToWebTableHeaderComponent>
                    <SellToWebTableRowComponent>
                        <SellToWebTableColumnComponent headerText="#" dataColumn={CommonService.ordinalColumnName} dataType="number" sortColumn={CommonService.ordinalColumnName} />
                        <SellToWebTableColumnComponent headerText="YMMT" dataColumn="ymmt" sortColumn="ymmt" filterColumn="ymmt" className="admin-evox-mmr-ymmt admin-evox-mmr-ymmt-width" />
                        <SellToWebTableColumnComponent headerText="YMMT" dataColumn="evoxDisplayName" sortColumn="evoxDisplayName" filterColumn="evoxDisplayName" dataColumnCallback={this.onVIFDataColumnCallback} className="admin-evox-mmr-ymmt-width" />
                        <SellToWebTableColumnComponent headerText="Action" dataColumnCallback={this.onActionColumnCallback} headerClassName="admin-evox-mmr-action-col" columnHelp="Save (Ctrl+S)<br/> Save to Model (Ctrl+M)<br/> Undo (Ctrl+U)<br/> Remove (Ctrl+R)" columnHelpCssName="admin-evox-mmr-action-columnHelp-width" />
                        <SellToWebTableColumnComponent headerText="VIF" dataColumnCallback={this.onVifNumberColumnCallback} dataColumn="vifNumber" sortColumn="vifNumber" filterColumn="vifNumber" headerCssName="text-nowrap" />
                        <SellToWebTableColumnComponent headerText="Date Delivered" dataColumn="dateDelivered" sortColumn="dateDelivered" filterColumn="dateDelivered" headerCssName="text-nowrap" dataType="date" />
                        <SellToWebTableColumnComponent headerText="Mapped By" dataColumn="vifMappedBy" sortColumn="vifMappedBy" filterColumn="vifMappedBy" headerCssName="text-nowrap" dataColumnCallback={this.onMappedByColumnCallback} />
                        <SellToWebTableColumnComponent headerText="Image Product" dataColumn="imageProductDownloaded" sortColumn="imageProductDownloaded" filterColumn="imageProductDownloaded" headerCssName="text-nowrap" />
                        <SellToWebTableColumnComponent headerText="Images" className="text-nowrap" dataColumnCallback={this.onPhotoColumnCallback} />
                        <SellToWebTableColumnComponent headerText="Comment" dataColumn="comment" sortColumn="comment" filterColumn="comment" />
                    </SellToWebTableRowComponent>
                </SellToWebTableComponent>
            </div>
        </div>;
    }
}